import {apiInstance} from '../api_Instance';
import {queryOptions, infiniteQueryOptions, keepPreviousData} from '@tanstack/react-query';
export const brandFilterApi = {
  getBrandList: (carTypeId) => {
    return queryOptions({
      queryKey: ['brand', 'list', carTypeId],
      queryFn: (meta) =>
        apiInstance.get(`/carbrands/?type=${carTypeId}`, {
          signal: meta.signal,
        }),
      enabled: !!carTypeId,
      select: (data) => {
        return data.data.map((brandData) => ({
          id: brandData.id,
          value: brandData.id,
          text: brandData.brand,
        }));
      },
    });
  },
  getModelsList: (carTypeId, brandId) => {
    return queryOptions({
      queryKey: ['model', brandId],
      queryFn: (meta) =>
        apiInstance.get(`/carmodels/?brand_id=${brandId}&model_type_id=${carTypeId}`, {
          signal: meta.signal,
        }),
      enabled: !!brandId,
      select: (data) => {
        return data.data.map((modelData) => ({
          id: modelData.id,
          value: modelData.id,
          text: modelData.name,
        }));
      },
    });
  },
  getYearList: (modelId) => {
    return queryOptions({
      queryKey: ['year', modelId],
      queryFn: (meta) =>
        apiInstance.get(`/engines/?car_model_id=${modelId}`, {
          signal: meta.signal,
        }),
      enabled: !!modelId,
      select: (data) => {
        const uniqueDates = {};
        data.data.forEach((yearData) => {
          if (!uniqueDates[yearData.date_start]) {
            uniqueDates[yearData.date_start] = {
              id: yearData.id,
              value: yearData.date_start,
              text: yearData.date_start,
            };
          }
        });
        const sortedDates = Object.values(uniqueDates).sort(
          (a, b) => new Date(b.value) - new Date(a.value)
        );

        return sortedDates;
      },
    });
  },
  getVName: (date_start, modelId) => {
    return queryOptions({
      queryKey: ['date_start', date_start],
      queryFn: (meta) =>
        apiInstance.get(`/engines/?car_model_id=${modelId}&date_start=${date_start}`, {
          signal: meta.signal,
        }),
      enabled: !!date_start,
      select: (data) => {
        const uniqueNames = {};
        data.data.forEach((vNameData) => {
          if (!uniqueNames[vNameData.name]) {
            uniqueNames[vNameData.name] = {
              id: vNameData.id,
              value: vNameData.name,
              text: vNameData.name,
            };
          }
        });
        return Object.values(uniqueNames);
      },
    });
  },
  getEngineList: (vName, modelId, date_start) => {
    return queryOptions({
      queryKey: ['vName', vName],
      queryFn: (meta) =>
        apiInstance.get(
          `/engines/?car_model_id=${modelId}&date_start=${date_start}&name=${vName}`,
          {
            signal: meta.signal,
          }
        ),
      enabled: !!vName,
      select: (data) => {
        return data.data.map((engineData) => ({
          id: engineData.id,
          value: engineData.id,
          code_engine: engineData.code_engine,
          kilowatt: engineData.kilowatt,
          power: engineData.power,
          image: engineData.image,
          car_model_id: engineData.car_model_id,
          brand_id: engineData.brand_id,
          fuel: engineData.fuel,
        }));
      },
    });
  },

  getProductListInfinit: (engineId) => {
    return infiniteQueryOptions({
      queryKey: ['products', engineId],
      enabled: !!engineId,
      queryFn: (meta) =>
        apiInstance.get(`/products/`, {
          params: {
            page: meta.pageParam,
            product_engines__engine_id: engineId,
          },
          signal: meta.signal,
        }),
      initialPageParam: 1,
      getNextPageParam: (result) => result.data.next,
      select: (result) => result.pages.flatMap((page) => page.data.results),
    });
  },
  getProductsByOEMInfinite: (enabled, category_id) => {
    return infiniteQueryOptions({
      queryKey: ['productsOemInfinit', enabled, category_id],
      enabled: !!enabled,
      queryFn: (meta) =>
        apiInstance.get(`/products`, {
          params: {
            page: meta.pageParam,
            part_number: enabled,
            category_id: category_id,
          },
          signal: meta.signal,
        }),
      initialPageParam: 1,
      getNextPageParam: (result) => {
        return result.data.next;
      },
      select: (result) => result.pages.flatMap((page) => page.data.results),
    });
  },
  getProductsByOEM: (enabled, category_id) => {
    return queryOptions({
      queryKey: ['productsOem', enabled, category_id],
      enabled: !!enabled,
      queryFn: () =>
        apiInstance.get(`/products`, {
          params: {
            part_number: enabled,
            category_id: category_id,
          },
        }),
      select: (data) => {
        const a = data.data.results;
        return a;
      },
    });
  },
};
